module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('div', {
    staticClass: "site-box",
    attrs: {
      "slot": "sidebar"
    },
    slot: "sidebar"
  }, [_c('category-list', {
    attrs: {
      "category": this.$store.state.sceneList,
      "groupId": _vm.groupId
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "site-box",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "markdown-container"
  }, [_c('vue-markdown', {
    attrs: {
      "source": _vm.markdown
    }
  })], 1), _vm._v(" "), _c('scroll-nav', {
    attrs: {
      "scrollList": _vm.scrollList
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-11f1452c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/index/pages/Scene.vue
// module id = 690
// module chunks = 4